"use strict";

reservationCampaignService.$inject = ["api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reservationCampaignService = reservationCampaignService;

var _marked = require("marked");

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function reservationCampaignService(api) {

    return {
        setReservationCampaign: setReservationCampaign,
        getReservationCampaign: getReservationCampaign,
        getActiveReservationCampaigns: getActiveReservationCampaigns
    };

    function getReservationCampaign(code) {

        return api.reservationCampaign.get({ code: code }).$promise.then(function (resource) {
            resource.campaign.text = (0, _marked2.default)(resource.campaign.text || '');
            resource.canReserve = !!resource.reservations.find(function (product) {
                return !product.totalLimitReached;
            });
            return resource;
        });
    }

    function getActiveReservationCampaigns() {
        return api.getActiveReservationCampaigns.get({}).$promise.then(function (resource) {
            return resource;
        });
    }

    function setReservationCampaign(code, reservations) {
        var reservationsPost = [];
        reservations.forEach(function (reservation) {
            reservationsPost.push({
                productNumber: reservation.productNumber,
                amount: reservation.amount
            });
        });

        return api.setReservationCampaignAmounts.set({ code: code }, {
            code: code,
            reservations: reservationsPost
        }).$promise.then(function () {
            return getReservationCampaign(code);
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/reservationCampaignService.js
// module id = 827
// module chunks = 0